import React, { Component } from 'react'
import UserIcon_1 from '../../images/UserIcon_1.png'
import $ from 'jquery'
import { Link } from 'react-router-dom'
import * as Common from './CommonJs'
import AppLogo_white from '../../images/AppLogo_white.jpeg'
import { connect } from 'react-redux'

const mapStateToProps = (state) => {
  return state.UserAuthentication.UserInfo
}

class Topmenu extends Component {
  constructor(props) {
    super(props)
    this.state = { toggleSideBar: false }
  }

  toggleSideBar = (toggleSideBar) => {
    document.getElementById('left-panel').style.width = toggleSideBar
      ? '260px'
      : '0%'
    document.getElementById('left-panel').style.maxWidth = toggleSideBar
      ? '260px'
      : '0%'
    this.setState({ toggleSideBar })
  }

  render() {
    return (
      <header id="header" className="header">
        <div className="top-left">
          <div className="navbar-header">
            <i
              className="fa fa-solid fa-bars menu-bar"
              onClick={() => this.toggleSideBar(!this.state.toggleSideBar)}
            ></i>
            <Link to="/Dashboard">
              <img src={AppLogo_white} style={{ height: '50px' }} />
            </Link>
          </div>
        </div>

        <div className="top-right">
          <div className="header-menu">
            <div className="header-left ">
              <span className="PageTopTitle">{this.props.PageTitle}</span>
            </div>
            <div
              className="user-area header-right dropdown float-right"
              style={{ display: 'contents' }}
            >
              <div
                hidden={!this.props.isShowAddBtn}
                style={{ marginRight: '15px' }}
              >
                <Link to={this.props.AddBtnLink ?? ""}>
                  <button className="btn TopMenu_Addbtn">
                    <i
                      style={{ color: 'white', marginRight: '5px' }}
                      className="fa fa-plus-circle"
                      aria-hidden="true"
                    ></i>
                    {this.props.AddBtnLabel}
                  </button>
                </Link>
              </div>

              <div hidden={this.props.isShowPrintBtn == true ? false : true}>
                <button
                  onClick={this.props.showHideFilters}
                  className="btn TopMenu_Addbtn"
                >
                  <i
                    style={{
                      color: 'white',
                      marginRight: '5px',
                      marginLeft: '5px',
                    }}
                    className="fa fa-sliders"
                    aria-hidden="true"
                  ></i>
                  <span>Filters</span>
                </button>

                <button
                  onClick={() => {
                    document.getElementById('Componentprintlink').click()
                  }}
                  className="btn TopMenu_Addbtn"
                >
                  <i
                    style={{ color: 'white', marginRight: '5px' }}
                    className="fa fa-print"
                    aria-hidden="true"
                  ></i>
                  <span>Print Dashboard</span>
                </button>
              </div>

              <a
                href="#"
                className="dropdown-toggle active"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ marginRight: '15px', marginLeft: 15 }}
              >
                <img
                  className="user-avatar rounded-circle"
                  src={
                    this.props.imageURLBase64 == '' ||
                    this.props.imageURLBase64 == undefined ||
                    this.props.imageURLBase64 == null
                      ? UserIcon_1
                      : this.props.imageURLBase64
                  }
                  alt="User Avatar"
                />
              </a>

              <div className="user-menu dropdown-menu">
                <Link
                  hidden={+this.props.roleId === 4 || +this.props.roleId === 5}
                  className="nav-link"
                  to="/User_Profile"
                >
                  <i className="fa fa-cog"></i>Profile Settings
                </Link>
                <Link
                  hidden={+this.props.roleId === 4 || +this.props.roleId === 5}
                  className="nav-link"
                  to="/Change_Password"
                >
                  <i className="fa fa-user-o"></i>Change Password
                </Link>
                <a
                  className="nav-link"
                  style={{ cursor: 'pointer' }}
                  onClick={this.LogOut}
                >
                  <i className="fa fa-sign-out"></i>Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  }

  componentWillMount() {}

  LogOut = () => {
    if (
      localStorage.DBVersion == undefined ||
      localStorage.DBVersion != 'V3.8'
    ) {
      localStorage.clear()
      window.location.href = '/'
    } else {
      localStorage.clear()
      localStorage.DBVersion = 'V3.8'
      window.location.href = '/'
    }
  }
}

export default connect(mapStateToProps)(Topmenu)
